<!-- <div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div> -->
<div class="modal-body">
  <div class="modal-text-wrapper modal_body">
    <p>{{information}}</p>
  </div>
  
  <button type="button" class="modal-btn-primary" (click)="activeModal.close('Close click')">{{positiveButton}}</button>
</div>
<!-- <div class="modal-footer">
</div> -->
